import { Yield } from '../../abacus/interfaces/yield.interface'

export const initiativeTypeYields: Yield[] = [
  {
    label: 'Name',
    property: 'name'
  },
  {
    label: 'Category',
    property: 'category'
  },
  {
    label: 'AI Principle',
    property: 'aiPrinciple.name'
  }
]
